import React from "react";
import { ColumnsType } from "antd/es/table";
import type { SortOrder } from "antd/es/table/interface";
import { TFunction } from "i18next";

/** Колонки таблицы отчётных периодов, по которым возможна клиентская сортировка */
export const ACCOUNTING_SORTABLE_COLUMNS = [
  "Year",
  "Quarter",
  "reportDate",
  "lastDate",
];

const COMPARATORS: Record<string, (a: any, b: any) => number> = {
  Year: (a, b) => (a.Year ?? 0) - (b.Year ?? 0),
  Quarter: (a, b) => (a.Quarter ?? 0) - (b.Quarter ?? 0),
  reportDate: (a, b) => (a.reportDateRaw ?? 0) - (b.reportDateRaw ?? 0),
  lastDate: (a, b) => (a.lastDateRaw ?? 0) - (b.lastDateRaw ?? 0),
};

const resolveSortProps = (
  key: string,
  sortField?: string,
  sortType?: string,
) => {
  const comparator = COMPARATORS[key];
  if (!comparator) return {};

  const sortOrder: SortOrder | undefined =
    sortField === key && (sortType === "ASC" || sortType === "DESC")
      ? sortType === "DESC"
        ? "descend"
        : "ascend"
      : undefined;

  return { sorter: comparator, sortOrder };
};

export const getAccountingPeriodColumns = (
  t: TFunction,
  onYearClick: (record: any) => void,
  sortField?: string,
  sortType?: string,
): ColumnsType<any> => [
  {
    title: t("accounting.Year"),
    dataIndex: "Year",
    key: "Year",
    ...resolveSortProps("Year", sortField, sortType),
    render: (value: any, record: any) => (
      <span
        style={{ cursor: "pointer", color: "#e37639" }}
        onClick={() => onYearClick(record)}
      >
        {value}
      </span>
    ),
  },
  {
    title: t("accounting.Quarter"),
    dataIndex: "Quarter",
    key: "Quarter",
    ...resolveSortProps("Quarter", sortField, sortType),
  },
  {
    title: t("accounting.reportDate"),
    dataIndex: "reportDate",
    key: "reportDate",
    ...resolveSortProps("reportDate", sortField, sortType),
  },
  {
    title: t("accounting.lastDate"),
    dataIndex: "lastDate",
    key: "lastDate",
    ...resolveSortProps("lastDate", sortField, sortType),
  },
];
